@if (dialogData.member.relationshipCode === cardHolderRC) {
  <h4
    class="modal-header"
    >
    New Cardholder Added
    <span class="close-icon"><mat-icon (click)="cancel(false)">close</mat-icon></span>
  </h4>
}

@if (dialogData.member.relationshipCode !== cardHolderRC) {
  <h4
    class="modal-header"
    >
    New Dependent Added
    <span class="close-icon"><mat-icon (click)="cancel(false)">close</mat-icon></span>
  </h4>
}

<div class="info-section">
  <div class="left-section">
    <div class="info-item">
      <label>Name</label>
      <p>
        {{ dialogData.member.firstName }}
        {{ dialogData.member.lastName }}
      </p>
    </div>
    <div class="info-item">
      <label>DOB</label>
      <p>{{ dialogData.member.dateOfBirth | timeStampToDate }}</p>
    </div>
    <div class="info-item">
      <label>Gender</label>
      <p>{{ displayGender[dialogData.member.gender] }}</p>
    </div>
  </div>

  <div class="middle-section">
    <div class="info-item">
      <label>Card ID</label>
      <p>{{ dialogData.member.patientNum }}</p>
    </div>
    <div class="info-item">
      <label>Coverage Type</label>
      <p>{{ dialogData.member.coverageType }}</p>
    </div>
    <div class="info-item">
      <label>Effective Date</label>
      <p>{{ dialogData.member.startDate | timeStampToDate }}</p>
    </div>
  </div>

  <div class="right-section">
    <div class="info-item">
      <label>Address</label>
      <p>
        {{
        dialogData.member.addressLine1 +
        ", " +
        (dialogData.member.addressLine2
        ? dialogData.member.addressLine2 + ", "
        : "") +
        dialogData.member.city +
        ", " +
        dialogData.member.state +
        ", " +
        dialogData.member.zipCode
        }}
      </p>
    </div>
    <div class="info-item">
      <label>Contact</label>
      <p>
        {{ phoneLabels[dialogData?.member.PhoneType] }} -
        {{
        dialogData.member[dialogData?.member.PhoneType]
        ? formatPhoneNumber(dialogData.member[dialogData?.member.PhoneType])
        : ""
        }}
      </p>
    </div>
    <div class="info-item">
      <label>Email</label>
      <p>{{ dialogData.member.email ? dialogData.member.email : "-" }}</p>
    </div>
  </div>
</div>

<div class="mat-row dialog-btn-row">
  <div class="mat-12 flex justify-content-between" >
    <button mat-button class="primary-btn" (click)="navigateToAddDependent()">
      Add Dependent
    </button>
    <button
      mat-button
      class="primary-btn"
      (click)="navigateBackToMemberSearch()"
      >
      Back to Member Search
    </button>
  </div>
</div>
